// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"51":"b566e18b","76":"095af316"}[chunkId] + ".css";
};